import React, { Fragment, useEffect, useRef, useState } from "react";
import { KTSVG } from "../../../_metronic/helpers";
import { useAppSelector, useAppDispatch } from "../../../app/hooks";
import { CurrenciesInitialsForAdd, CurrenciesInitialsForUpdate } from "./interfaces/CurrenciesClass";
import { addAccountCurrencyAsync, updateAccountCurrencyAsync, validateNewCurrencyAsync, resetSelectedRecordObjectInState } from "./CurrenciesSlice";
import Select, { StylesConfig } from 'react-select';
import fetchAPI from "../../../common/fetchAPI";
import { ShowToast } from '../../../common/Toastr';
import * as yup from 'yup';
import { Formik, useFormik, useFormikContext } from 'formik';
import { formatNumberCustomoriginalapiv2, parseLocalizedNumber, validateCultureNumber, determineCommaSeprater, dropDownSelectionStyles, getValueFromResource } from '../../../common/timeLiveFunction';
import infoSVG from "../../../assets/image/info-SVG.svg";
import { Tooltip as ReactTooltip } from 'react-tooltip';
import { TOOLTIP_STYLE } from "../../../common/TooltipStyle";



export const CurrenciesForm = (props: any) => {
    const [disabledCount, setDisabledCount] = useState(0)
    const { t, onToggleModal, CurrenciesArray } = props;
    const { decimalPlaces, cultureInfoName, maxMenuHeight } = useAppSelector(state => state.globalState);
    const { selectedRecord, IsCurrencyExsist, CurrenciesList, isLoading, AccountBaseCurrencyId } = useAppSelector((state) => state.currencies);
    const [currentFieldsData, SetcurrentFieldsData] = useState<any>(CurrenciesInitialsForAdd);
    const dispatch = useAppDispatch();
    const [selectedOptionDropDown, setSelectedOptionDropDown] = useState<{ value: string; label: string } | null>(null);
    const closeButtonRef = useRef<HTMLButtonElement | null>(null);
    const isBaseCurrency = AccountBaseCurrencyId === (selectedRecord as any)?.AccountCurrencyId;

    const formik = useFormik({
        initialValues: {
            ...currentFieldsData,
            SystemCurrencyId: selectedOptionDropDown?.value || "",
        },
        enableReinitialize: true,
        validationSchema: yup.object().shape({
            SystemCurrencyId: yup
                .string()
                .required
                // (t('Currency is required')),
                (getValueFromResource('Currency is required',dispatch, t)),
            ExchangeRate: yup.string()
        .required(getValueFromResource('Exchange Rate is required', dispatch, t))
        .test(
            'culture-format-check',
            () => {
                const isComma = determineCommaSeprater(cultureInfoName.toString());
                return isComma
                    ? getValueFromResource('Only numbers and comma (,) allowed', dispatch, t)
                    : getValueFromResource('Only numbers and dot (.) allowed', dispatch, t);
            },
            (value) => {
                if (!value) return false; // Changed to false since field is required
                const isComma = determineCommaSeprater(cultureInfoName.toString());
                return isComma ? /^\d+(,\d+)?$/.test(value) : /^\d+(\.\d+)?$/.test(value);
            }
        )
        .test(
            'greater-than-zero',
            getValueFromResource('Exchange Rate must be greater than 0', dispatch, t),
            (value) => {
                if (!value) return false; // Changed to false since field is required
                const isComma = determineCommaSeprater(cultureInfoName.toString());
                const normalizedValue = isComma ? value.replace(',', '.') : value;
                const numberValue = parseFloat(normalizedValue);
                return !isNaN(numberValue) && numberValue > 0; // Changed from >= 0 to > 0
            }
        )
        }),
        onSubmit: (values, action) => {
            handleSubmit(values);
            action.resetForm();
        },
    });

    useEffect(() => {
        let stateItem: any = {}
        if (Object.keys(selectedRecord).length > 0) {
            const tempObj: any = selectedRecord;
            Object.keys(CurrenciesInitialsForUpdate).map((item) => {
                return stateItem[item] = tempObj[item];
            })
            stateItem.Disabled = stateItem.Disabled === 'Yes' ? true : false;
            stateItem.ExchangeRate = formatNumberCustomoriginalapiv2(cultureInfoName.toString(), stateItem.ExchangeRate, decimalPlaces);

            SetcurrentFieldsData(stateItem);
            setSelectedOptionDropDown({ value: stateItem.SystemCurrencyId, label: stateItem.CurrencyCode + ' - ' + stateItem.Currency });
        }
        else {
            SetcurrentFieldsData(CurrenciesInitialsForAdd);
            setSelectedOptionDropDown(null);
            formik.resetForm();
        }
        calculatedDisabledValue();

    }, [selectedRecord])

    const handleSubmit = (values: any) => {
        if (Object.keys(selectedRecord).length > 0) {
            const normalizedExchangeRateValue = parseLocalizedNumber(values.ExchangeRate);

            const updatedValues = {
                ...values,
                ExchangeRate: normalizedExchangeRateValue
            };
            dispatch(updateAccountCurrencyAsync(updatedValues))
                .unwrap()
                .then((originalPromiseResult) => {
                    originalPromiseResult.StatusCode === "200" ?
                        ShowToast("Currency Update Successfully", 'Success', "success", "toast-top-right") :
                        ShowToast('error', originalPromiseResult.ResponseMessage, "error", "toast-top-right");
                })
                .catch((rejectedValueOrSerializedError) => {
                })
        }
        else {
            const normalizedExchangeRateValue = parseLocalizedNumber(values.ExchangeRate);

            const updatedValues = {
                ...values,
                ExchangeRate: normalizedExchangeRateValue
            };
            dispatch(addAccountCurrencyAsync(updatedValues))
                .unwrap()
                .then((originalPromiseResult) => {
                    originalPromiseResult.StatusCode === "201" ?
                        ShowToast("Currency Added Successfully", 'Success', "success", "toast-top-right") :
                        ShowToast('error', originalPromiseResult.ResponseMessage, "error", "toast-top-right");
                })
                .catch((rejectedValueOrSerializedError) => {
                })
        }
        onToggleModal();
    }
    const handleCloseOnClickEvent = () => {
        dispatch(resetSelectedRecordObjectInState());
        onToggleModal();
    }
    const calculatedDisabledValue = () => {
        if (CurrenciesList.length > 0) {
            let index = 0;
            CurrenciesList.forEach((value) => {
                if (value.Disabled.toString() == 'Yes') {
                    index = index + 1
                }
            });
            setDisabledCount(CurrenciesList.length - index);
        }
    }
    return (
        <>
            <div className="modal drawer-overlay" style={{ display: 'block' }}>
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header" style={{ padding: '.6rem .6rem' }}>
                            <h5 className="modal-title mainHeading">{Object.keys(selectedRecord).length > 0 ? 
                            // t('Update') 
                            getValueFromResource('Update ',dispatch, t)
                            : 
                            // t('Add')} 
                            getValueFromResource('Add ',dispatch, t)}
                            {/* {t('Currencies')}  */}
                            {getValueFromResource('Currencies',dispatch, t)}

                            </h5>
                            <div
                                className="btn btn-icon btn-sm btn-active-secondary ms-2 "
                                onClick={onToggleModal}
                            >
                                <KTSVG
                                    path="/media/icons/duotune/arrows/arr061.svg"
                                    className="svg-icon svg-icon-1x"
                                />
                            </div>
                        </div>
                        <div className="modal-body">
                            <div className="mb-3">
                                <label className="fs-7 fs-7 fw-normal">
                                    {/* {t('Name')} */}
                                    {getValueFromResource('Name',dispatch, t)}

                                    </label>
                                <Select
                                    value={formik.values.SystemCurrencyId == "" ? CurrenciesArray[0] : CurrenciesArray.find((option: any) => option.value == formik.values.SystemCurrencyId)}
                                    className="basic-single mt-2"
                                    classNamePrefix="select"
                                    isSearchable={true}
                                    name="SystemCurrencyId"
                                    id="SystemCurrencyId"
                                    onBlur={() => formik.setFieldTouched('SystemCurrencyId', true)}
                                    onChange={(selectedOption) => {
                                        formik.handleChange({
                                            target: {
                                                id: "SystemCurrencyId",
                                                value: selectedOption?.value
                                            },

                                        });
                                        dispatch(validateNewCurrencyAsync(selectedOption?.value));

                                    }}
                                    options={CurrenciesArray}
                                    styles={dropDownSelectionStyles}
                                    maxMenuHeight={maxMenuHeight}
                                    isDisabled={Object.keys(selectedRecord).length > 0}
                                />
                                <div>
                                    {formik.touched.SystemCurrencyId && formik.errors.SystemCurrencyId &&
                                        <p className='errorMsg'>{formik.errors.SystemCurrencyId as string}</p>
                                    }
                                </div>
                            </div>
                            <div className="mb-3 mt-2">
                                <label className="fs-7 fs-7 fw-normal d-flex align-items-center gap-1">
                                    {/* {t('Exchange Rate')} */}
                                    {getValueFromResource('Exchange Rate', dispatch, t)}
                                    <div
                                        style={{ marginBottom: "2px" }}
                                        data-tooltip-id="tooltip-currency"
                                        data-tooltip-content={getValueFromResource('Define the exchange rate of this currency relative to the system’s base currency. For example, if the base currency is USD and you add GBP, an exchange rate of 0.75 means 1 USD = 0.75 GBP.', dispatch, t)}
                                    >
                                        <img src={infoSVG} alt="" width={12} height={12} className="tooltip-info-icon" />
                                    </div>

                                </label>
                                <input type="text"
                                    className="form-control fs-7 fw-normal mt-2"
                                    id='ExchangeRate'
                                    name="ExchangeRate"
                                    value={formik.values.ExchangeRate}
                                    //onChange={formik.handleChange('ExchangeRate')}
                                    onBlur={() => formik.setFieldTouched('ExchangeRate')}
                                    onChange={(e) => {
                                        const value = e.target.value;

                                        if (validateCultureNumber(value, cultureInfoName.toString(), decimalPlaces)) {
                                            formik.setFieldValue('ExchangeRate', value);

                                        }
                                    }}
                                    readOnly={Object.keys(selectedRecord).length > 0}
                                // onKeyDown={(e) => {
                                //     if (e.key === 'Enter') {
                                //         e.preventDefault();
                                //         handleSubmit(e);
                                //     }
                                // }}
                                />
                                <div>
                                    {formik.touched.ExchangeRate && formik.errors.ExchangeRate &&
                                        <p className='errorMsg'>{formik.errors.ExchangeRate as string}</p>
                                    }
                                </div>
                            </div>
                            {/* {(Object.keys(selectedRecord).length > 0) ? (
                                <div className="mb-3">
                                    <label className="fs-7 fs-7 fw-normal mb-2 ">{t('Disabled')}</label>
                                    <div className="form-check form-switch form-check-custom form-check-solid me-10">
                                        <input className="form-check-input h-20px w-30px"
                                            type="checkbox"
                                            checked={formik.values.Disabled}
                                            id="Disabled"
                                            name="Disabled"
                                            onChange={formik.handleChange('Disabled')}
                                        />
                                    </div>
                                </div>
                            ) : null} */}
                            {Object.keys(selectedRecord).length > 0 && !isBaseCurrency ? (
                                disabledCount !== 1 ? <div className="mb-3" >
                                    <label className="fs-7 fw-normal mt-2">
                                        {/* {t('Disabled')} */}
                                        {getValueFromResource('Disabled',dispatch, t)}

                                        </label>
                                    <div className="form-check form-switch form-check-custom form-check-solid me-10">
                                        <input className="form-check-input h-20px w-30px mt-2" type="checkbox" checked={formik.values.Disabled} id="IsDisabled"
                                            onChange={formik.handleChange('Disabled')}
                                        />
                                    </div>
                                </div> : CurrenciesList.find(x => x.AccountCurrencyId === formik.values.AccountCurrencyId)?.Disabled.toString() === "Yes" && (<div className="mb-3" >
                                    <label className="fs-7 fw-normal mt-2">
                                        {/* {t('Disabled')} */}
                                        {getValueFromResource('Disabled',dispatch, t)}

                                        </label>
                                    <div className="form-check form-switch form-check-custom form-check-solid me-10">
                                        <input className="form-check-input h-20px w-30px mt-2" type="checkbox" checked={formik.values.Disabled} id="IsDisabled"
                                            onChange={formik.handleChange('Disabled')}
                                        />
                                    </div>
                                </div>)
                            ) : null}

                        </div>
                        <div className="modal-footer" style={{ padding: '.6rem .6rem' }}>
                            <button
                                type="button"
                                className="btn btn-secondary btn-bs-btn-font-weight btn-sm"
                                onClick={handleCloseOnClickEvent}
                            >
                                {/* {t('Cancel')} */}
                                {getValueFromResource('Cancel',dispatch, t)}

                            </button>
                            <button type="button" className="btn btn-primary  btn-bs-btn-font-weight btn-sm"
                                onClick={() => formik.handleSubmit()} disabled={!formik.isValid || IsCurrencyExsist === 'False' ? true : false}
                            >
                                {/* {t('Save')} */}
                                 {getValueFromResource('Save',dispatch, t)}

                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <ReactTooltip
                id="tooltip-currency"
                style={TOOLTIP_STYLE}
                place="top"
                delayShow={100}
                delayHide={100}
                clickable
                render={({ content }) => {
                    const isLongContent = content && content?.length > 90;
                    return (
                        <div style={{ maxWidth: isLongContent ? '380px' : '220px' }}>
                            {content}
                        </div>
                    );
                }}
            />
        </>
    )

}
const colourStyles: StylesConfig = {
    control: (styles) => ({ ...styles, backgroundColor: 'white', width: '100%', minHeight: '36px', height: '36px', padding: '-1px' }),
}
